import { render } from "./Edit.vue?vue&type=template&id=3d94e199&bindings={\"errors\":\"props\",\"tenant\":\"props\",\"timezones\":\"props\",\"form\":\"data\",\"update\":\"options\"}"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3d94e199"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d94e199')) {
    api.reload('3d94e199', script)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=3d94e199&bindings={\"errors\":\"props\",\"tenant\":\"props\",\"timezones\":\"props\",\"form\":\"data\",\"update\":\"options\"}", () => {
    api.rerender('3d94e199', render)
  })

}

script.__file = "resources/js/Pages/Tenants/Edit.vue"

export default script